import { useContext } from 'react';
import { Form, Flex, FormContext } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import { GetSaleTeamsForPropertySelectQuery } from 'gql/generated.graphql';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

const SaleTeamSelect = ({
  saleTeamsList,
  saleTeamIndex,
  disabled,
}: {
  saleTeamsList?: GetSaleTeamsForPropertySelectQuery['getSaleTeams']['collection'];
  saleTeamIndex: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, stateHandlers, formState } = useContext(FormContext);
  const selectedSaleTeams = formState[FormFields.SaleTeams] || [];
  const selectedSaleTeamIds: string[] = selectedSaleTeams.map(
    (doc: any) => doc.saleTeamId
  );

  const setSaleTeam = (value: string) => {
    const saleTeams = [...formState[FormFields.SaleTeams]];
    const prevSaleTeam = saleTeams[saleTeamIndex] || {};

    saleTeams[saleTeamIndex] = value
      ? {
          ...prevSaleTeam,
          saleTeamId: value,
          saleDirectorId: null,
          saleAssociateIds: [],
        }
      : {};

    stateHandlers[FormFields.SaleTeams](saleTeams);
  };

  return (
    <Flex flexDirection="column" mr={2} flex={1} w="100%">
      <Form.Label>{t('forms:labels.salesTeam')}</Form.Label>
      <Form.Select
        isClearable
        menuPortalZIndex="auto"
        options={saleTeamsList?.map((item: any) => ({
          value: item._id,
          label: item.name,
          isDisabled: selectedSaleTeamIds.includes(item._id),
        }))}
        onChanged={setSaleTeam}
        value={formState[FormFields.SaleTeams]?.[saleTeamIndex]?.saleTeamId}
        placeholder={t('forms:placeholders.salesTeam')}
        w="100%"
        disabled={disabled}
        $errorType={formErrors[FormFields.SaleTeams]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.SaleTeams]?.type}>
        {formErrors[FormFields.SaleTeams]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default SaleTeamSelect;
